import merge from 'lodash/merge';
import { commonUrls } from '@atlassian/eoc-schedule-common';
const urls = Object.freeze(merge({
  schedules: {
    url: () => `/v1/schedules`,
    scheduleId: {
      url: ({
        scheduleId
      } = {
        scheduleId: ':scheduleId'
      }) => `/v1/schedules/${scheduleId}`,
      clone: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/clone`
      },
      name: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/name`
      },
      timezone: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/timezone`
      },
      enable: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/enable`
      },
      disable: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/disable`
      },
      webCalendarUrl: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/web-calendar-url`
      },
      timeline: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/timeline`
      },
      overrides: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/overrides`,
        alias: {
          url: ({
            scheduleId,
            alias
          } = {
            scheduleId: ':scheduleId',
            alias: ':alias'
          }) => `/v1/schedules/${scheduleId}/overrides/${alias}`
        },
        bulk: {
          url: ({
            scheduleId
          } = {
            scheduleId: ':scheduleId'
          }) => `/v1/schedules/${scheduleId}/overrides/bulk`
        }
      },
      rotations: {
        url: ({
          scheduleId
        } = {
          scheduleId: ':scheduleId'
        }) => `/v1/schedules/${scheduleId}/rotations`,
        rotationId: {
          url: ({
            scheduleId,
            rotationId
          } = {
            scheduleId: ':scheduleId',
            rotationId: ':rotationId'
          }) => `/v1/schedules/${scheduleId}/rotations/${rotationId}`,
          order: {
            url: ({
              scheduleId,
              rotationId
            } = {
              scheduleId: ':scheduleId',
              rotationId: ':rotationId'
            }) => `/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
          },
          name: {
            url: ({
              scheduleId,
              rotationId
            } = {
              scheduleId: ':scheduleId',
              rotationId: ':rotationId'
            }) => `/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
          }
        }
      }
    },
    teams: {
      teamId: {
        url: ({
          teamId
        } = {
          teamId: ':teamId'
        }) => `/v1/schedules/teams/${teamId}`,
        rights: {
          url: ({
            teamId
          } = {
            teamId: ':teamId'
          }) => `/v1/schedules/teams/${teamId}/rights`
        }
      }
    },
    timeTemplates: {
      rotation: {
        url: () => '/v1/schedules/time-templates/rotation'
      }
    }
  },
  uiPreference: {
    schedule: {
      team: {
        teamId: {
          url: ({
            teamId
          } = {
            teamId: ':teamId'
          }) => `/v1/users/ui-preference/schedule/team/${teamId}`
        }
      }
    }
  },
  onboarding: {
    completeTask: {
      url: () => '/v1/onboarding/complete-task'
    }
  }
}, commonUrls));
export { urls };